export default __webpack_public_path__ + "static/media/FranceBinette.2d8bf97c.png";